function Player(playerData = {}) {
  this.attributes = playerData
  
  this.get = (attribute) => {
    return this.attributes[attribute]
  }
  
  this.set = (attribute, value) => {
    this.attributes[attribute] = value
  }
}

export default Player


// WEBPACK FOOTER //
// ./app/javascript/player/player.js